export default "/build/images/kia.png?5f6f4d48ac1034463588187113e1c477";